export enum OtpType {
    ForgotPassword = 1,

    SignInOrRegister = 2,

    DeleteUser = 3
}